import confetti from 'canvas-confetti';

export const runConfetti = () =>
  confetti({
    particleCount: 150,
    spread: 60,
    zIndex: 2000,
  });
